"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.regexp.exec");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getCountryCode = getCountryCode;
exports.getCountryDefaultLanguage = getCountryDefaultLanguage;
exports.supportedLanguagesMetadata = exports.countryDefaultLang = exports.tldCountryOverrideMap = exports.countryDefaultLangMap = void 0;

var _constants = require("./constants");

var countryDefaultLangMap = {
  ar: 'es-AR',
  au: 'en-AU',
  br: 'pt-BR',
  ca: 'en-CA',
  in: 'en-IN',
  nl: 'nl-NL',
  uk: 'en-GB',
  us: 'en-US'
};
exports.countryDefaultLangMap = countryDefaultLangMap;
var tldCountryOverrideMap = {
  com: 'us'
};
exports.tldCountryOverrideMap = tldCountryOverrideMap;

function getCountryCode() {
  var _matches$1$toLowerCas;

  var matches = _constants.domainCountryCodePtn.exec(_constants.hostname);

  var tld = (_matches$1$toLowerCas = matches === null || matches === void 0 ? void 0 : matches[1].toLowerCase()) !== null && _matches$1$toLowerCas !== void 0 ? _matches$1$toLowerCas : 'us';
  return tldCountryOverrideMap[tld] || tld;
}

function getCountryDefaultLanguage() {
  return countryDefaultLangMap[getCountryCode()] || 'en-US';
}

var countryDefaultLang = getCountryDefaultLanguage();
exports.countryDefaultLang = countryDefaultLang;

var languageObject = function languageObject(code, description, countryCodes, translations) {
  return {
    code: code,
    countryCodes: countryCodes,
    description: description,
    translations: translations
  };
};

var supportedLanguagesMetadata = [languageObject('en-US', 'English (United States)', ['us'], [{
  code: 'xx-XX',
  description: '[Ʃƞɠļɨšɧ (Ǔƞɨƭȅɗ Ѕƭăƭȅš)!!!!!!!!]'
}]), languageObject('en-GB', 'English (United Kingdom)', ['uk'], [{
  code: 'xx-XX',
  description: '[Ʃƞɠļɨšɧ (Ǔƞɨƭȅɗ Ќɨƞɠɗǒɱ)!!!!!!!!]'
}]), languageObject('en-AU', 'English (Australia)', ['au'], [{
  code: 'xx-XX',
  description: '[Ʃƞɠļɨšɧ (Ăʊšƭɾăļɨă)!!!!!!!]'
}]), languageObject('en-CA', 'English (Canada)', ['ca'], [{
  code: 'xx-XX',
  description: '[Ʃƞɠļɨšɧ (Ĉăƞăɗă)!!!!!!]'
}, {
  description: 'Anglais (Canada)'
}]), languageObject('en-IN', 'English (India)', ['in'], [{
  code: 'xx-XX',
  description: '[Ʃƞɠļɨšɧ (ɨƞɗɨă)!!!!!!!!]'
}]), languageObject('fr-CA', 'Français (Canada)', ['ca'], [{
  code: 'xx-XX',
  description: '[Ƒɾăƞçăɨš (Ĉăƞăɗă)!!!!!!]'
}, {
  description: 'French (Canada)'
}]), languageObject('es-AR', 'Español (Argentina)', ['ar'], [{
  code: 'xx-XX',
  description: '[Ʃšρăñǒļ (Ăɾɠȅƞƭɨƞă)!!!!!!!]'
}]), languageObject('pt-BR', 'Português (Brasil)', ['br'], [{
  code: 'xx-XX',
  description: '[Ƥǒɾƭʊɠʊêš (ßɾăšɨļ)!!!!!!]'
}]), languageObject('nl-NL', 'Nederlands (Nederland)', ['nl'], [{
  code: 'xx-XX',
  description: '[ƞêɗêɾļăƞɗš (ƞêɗêɾļăƞɗ)!!!!!!]'
}]), languageObject('xx-XX', '[Ƥšȅʊɗǒļǒĉăļɨʐȅɗ!!!!!]', ['us', 'uk', 'ca', 'au', 'in', 'ar', 'br', 'nl'], [{
  code: 'en-US',
  description: 'Pseudolocalized'
}, {
  code: 'en-GB',
  description: 'Pseudolocalised'
}, {
  code: 'en-CA',
  description: 'Pseudolocalized'
}, {
  code: 'en-AU',
  description: 'Pseudolocalized'
}, {
  code: 'en-IN',
  description: 'Pseudolocalized'
}, {
  code: 'es-AR',
  description: 'Pseudo Localizada'
}, {
  code: 'fr-CA',
  description: 'Pseudo Localisée'
}, {
  code: 'pt-BR',
  description: 'Pseudo Localizada'
}, {
  code: 'nl-NL',
  description: 'Pseudo Gelokaliseerde'
}])];
exports.supportedLanguagesMetadata = supportedLanguagesMetadata;
